import React, { useState } from 'react'
import LandingWrapper from './LandingWrapper'
import { IoCall } from 'react-icons/io5'
import { HiMailOpen } from 'react-icons/hi'
import { FaMapMarkerAlt } from 'react-icons/fa'
import Fade from 'react-reveal/Fade';
import './styles.css'

export default function LandingAPropos() {
  return (
    <div className='a-propos-cover'>
      <LandingWrapper>
        <div className="a-propos">
          <div className="landing_apropos-content">
            <Fade duration={3000} left>
              <Title />
            </Fade>
            <Description />
          </div>
        </div>
        <ContactUs />
      </LandingWrapper>
    </div>
  )
}

const Title = () => {
  return (
    <div className="landing-apropos__title">
      <p className='bold-title'>DKBSign La référence n°1</p>
      <p>pour la gestion des transactions numériques®</p>
    </div>
  )
}

const Description = () => {
  return (
    <div className="landing-apropos__description">
      <Fade duration={4000} left>
        <div className="landing-apropos__description-txt">
          Les entreprises qui ont réussi ont pour tradition d'adopter les nouvelles technologies en remplacement des processus manuels, lents et complexes, afin d'améliorer l'efficacité, de réduire les coûts et d'augmenter la satisfaction des clients. Sauf dans le cas de la collecte et de l'utilisation d'informations pour les transactions, où ce sont toujours les méthodes archaïques qui prévalent, surtout lorsque des signatures sont requises. Alors que les entreprises ont recours à des processus automatisés pour les opérations intervenant avant et après la signature effective, un grand nombre d'entre elles continuent de s'appuyer inutilement sur le papier pour conclure des affaires. Cela ralentit l'activité, retarde les résultats et nuit à l'expérience du client. Il ne devrait pas en être ainsi. Il n'y a aucune raison qu'il en soit ainsi. La plateforme de gestion des transactions numériques de DKBSign permet aux entreprises d'adopter des processus entièrement numériques, du début à la fin, et ainsi d'accélérer les transactions et de réduire les coûts, pour la plus grande satisfaction des clients, des partenaires, des fournisseurs et des employés.
        </div>
      </Fade>

      <Fade duration={4000} right>
        <img src="./assets/media/home_icon/preview-dkbsign.png" alt="landing-apropos__description-img" className='landing-apropos__description-img' />
      </Fade>
    </div>
  )
}

const ContactUs = () => {

  const [infos] = useState([
    {
      id: 1,
      icon: <IoCall size={25} color='white' />,
      info1: '(+225) 27 22 46 47 24',
      info2: ''
    },
    {
      id: 2,
      icon: <HiMailOpen size={25} color='white' />,
      info1: 'infos@dkbsolutions.com',
      info2: 'infos@dkbsign.com'
    },
    {
      id: 3,
      icon: <FaMapMarkerAlt size={25} color='white' />,
      info1: 'Abidjan, Cocody, Riviera Golf, Lot 92B, ilot 6,',
      info2: 'rue E127, pavillon Granit, 01 B.P. 6106 Abidjan 01'
    }
  ])

  const [options] = useState([
    {
      id: 1,
      label: 'Sélectionnez un sujet',
      value: 'Sélectionnez un sujet'
    },
    {
      id: 2,
      label: 'Sélectionnez un sujet',
      value: 'Sélectionnez un sujet'
    },
    {
      id: 3,
      label: 'Sélectionnez un sujet',
      value: 'Sélectionnez un sujet'
    },
  ])

  return (
    <div className="landing-apropos__contact-us">
      <Fade duration={3000} left>
      <div className="landing-apropos__integration-header">
        <h2>CONTACTEZ NOUS</h2>
      </div>
      </Fade>

      <Fade duration={3000} top>
      <div className="contact-us_content">
        <div className="contact-us_content_info">
          { infos.map(item => <InfoBlock key={item.id} item={item} />) }
        </div>

        <div className="contact-us_content_form">
          <div className="content_form">
            <div className="content_form-input_area">
              <Input label='Prénom*' type='text' placeholder='Prénom' name='firstname' />
              <Input label='Nom*' type='text' placeholder='Nom' name='lastname' />
            </div>

            <div className="content_form-input_area">
              <Input label='Email professionnel*' type='email' placeholder='Email' name='email' />
            </div>

            <div className="content_form-input_area">
              <Input label='Numéro de Télephone' type='text' placeholder='Numéro de téléphone' name='contact' />
              <Input label="Nom de l'entreprise " type='text' placeholder='Entreprise' name='entreprise' />
            </div>

            <div className="content_form-input_area">
              <Select label='Quelle est votre fonction ?' options={options} name='function' />
            </div>
            <p className='content_form-policy'>
              En cliquant sur le bouton "Envoyer", vous acceptez que vos données soient utilisées conformément à <a href="#">la politique de confidentialité de DkbSign</a>.
            </p>
            <a
              className='content_form-send'
              href="#">Envoyer</a>
          </div>
        </div>


      </div>
      </Fade>
    </div>
  )
}

const InfoBlock = ({ item }) => {
  return (
    <div className="contact-us_content_info-items">
      <div className="contact-us_content_info-items-icon">
        {item.icon}
      </div>
      <div className="contact-us_content_info-items-txt">
        <div className="contact-us_content_info-items-txt-p">{item.info1}</div>
        <div className="contact-us_content_info-items-txt-p">{item.info2}</div>
      </div>
    </div>
  )
}

const Input = ({ label, type, placeholder, name }) => {
  return (
    <div className="content_form-input">
      <label className="content_form-label" htmlFor={name}>{label}</label>
      <input className="content_form-element" type={type} name={name} placeholder={placeholder} />
    </div>
  )
}

const Select = ({ label, name, options }) => {
  return (
    <div className="content_form-input">
      <label className="content_form-label" htmlFor={name}>{label}</label>
      <select className="content_form-element" name={name}>
        {
          options.map(item => <option key={item.id} value={item.value}>{item.label}</option>)
        }
      </select>
    </div>
  )
}